module.exports = __webpack_public_path__ + "img/office365.c2801c01.svg";